
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.522 11.323h.954a.6.6 0 110 1.2h-1.2a1.8 1.8 0 01-1.8-1.8v-1.2a.6.6 0 111.2 0v.954l7.05-7.056a3.001 3.001 0 00-1.65-.498h-12a3 3 0 00-2.94 2.4h11.34a.6.6 0 110 1.2h-11.4v11.4a3 3 0 003 3h12a3 3 0 003-3v-12a3.002 3.002 0 00-.498-1.65l-7.056 7.05z","fill":"#B5B8B5"}})])
          )
        }
      }
    